import localForage from "localforage";

const cpAppStorage = localForage.createInstance({
  name: "cpBIHub",
  driver: localForage.LOCALSTORAGE,
  version: 1.0,
  storeName: "cpBiHubAppStorage",
  description: "Application Specific Data",
});

/** Store a value base64-encoded (JSON -> base64 string). */
const setItemEncoded = (key: string, value: unknown): Promise<string> => {
  const encoded = btoa(JSON.stringify(value));
  return cpAppStorage.setItem(key, encoded);
};

/** Retrieve and decode a value that was stored with setItemEncoded. */
const getItemDecoded = async <T>(key: string): Promise<T | null> => {
  const encoded = await cpAppStorage.getItem<string>(key);
  if (encoded === null || encoded === undefined) return null;
  try {
    return JSON.parse(atob(encoded)) as T;
  } catch {
    return null;
  }
};

const instance = {
  setItem: cpAppStorage.setItem.bind(cpAppStorage),
  getItem: cpAppStorage.getItem.bind(cpAppStorage),
  removeItem: cpAppStorage.removeItem.bind(cpAppStorage),
  clear: cpAppStorage.clear.bind(cpAppStorage),
  setItemEncoded,
  getItemDecoded,
};

export default instance;
